import { get, postDownload } from '../utils/api';

export default class PicTransactionsService {
  generatePicSubmission(
    organizationId: string,
    propertyId: string,
    affordableQualificationIds: string[],
    options?: Object,
  ): Promise<any> {
    return postDownload(
      `/${organizationId}/${propertyId}/pic-submissions/generate`,
      'pic-submission.asc',
      JSON.stringify({ affordableQualificationIds }),
      options,
    );
  }

  getAllPicTransactions(
    organizationId: string,
    propertyId: string,
    startDate?: string,
    endDate?: string,
    options?: Object,
  ): any {
    let finalQuery = '';
    if (startDate && !endDate) {
      finalQuery = `?startDate=${startDate}`;
    } else if (startDate && endDate) {
      finalQuery = `?startDate=${startDate}&endDate=${endDate}`;
    }
    return get(
      `/${organizationId}/${propertyId}/pic-transactions${finalQuery}`,
      options,
    );
  }
}
